import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import '../styles/floatingForm.css';
import { useNavigate } from 'react-router-dom';

const CreatePackageInPage = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(''); // no accordion open initially

  // Map each field to its accordion
  const fieldToAccordionMap = {
    departurePoint: "Departure",
    departureDate: "Departure",
    departureAirline: "Departure",

    arrivalPoint: "Arrival",
    arrivalDate: "Arrival",
    arrivalAirline: "Arrival",

    roomSharing: "room-details",


    imageFile: "images-details",
    bannerImageFile: "images-details",

    highlights: "highlights-details",
    included: "included-details",
    notIncluded: "not-included-details",
    requirement: "requirements-details",
    bookingPolicy: "booking-policy-details",
    cancellationPolicy: "cancellation-policy-details",
  };

  // --- Data lists ---
  const [producttype, setProducttype] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [departureCities, setDepartureCities] = useState([]);
  const [airlinesList, setAirlinesList] = useState([]);

  // --- Form fields ---
  const [packageName, setPackageName] = useState('');
  const [selectedProducttype, setSelectedProducttype] = useState('');
  const [selectedVendor, setSelectedVendor] = useState('');
 // const [city, setCity] = useState('');
  const [price, setPrice] = useState('');
  const [price_discount, setPrice_discount] = useState('');
  const [highlights, setHighlights] = useState('');
  const [included, setIncluded] = useState('');
  const [notIncluded, setNotIncluded] = useState('');
  const [requirement, setRequirement] = useState('');
  const [bookingPolicy, setBookingPolicy] = useState('');
  const [cancellationPolicy, setCancellationPolicy] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [bannerImageFile, setBannerImageFile] = useState(null);
  const [roomSharing, setRoomSharing] = useState('');
  const [roomDetails, setRoomDetails] = useState('');
  const [departurePoint, setDeparturePoint] = useState('');
  const [departureDate, setDepartureDate] = useState('');
  const [departureDetails, setDepartureDetails] = useState('');
  //const [departureAirline, setDepartureAirline] = useState('');
  const [arrivalPoint, setArrivalPoint] = useState('');
  const [arrivalDate, setArrivalDate] = useState('');
  const [arrivalDetails, setArrivalDetails] = useState('');
//  const [arrivalAirline, setArrivalAirline] = useState('');
  const [visa, setVisa] = useState('');
  const [visaDetails, setVisaDetails] = useState('');
  const [transfer, setTransfer] = useState('');
  const [transferDetails, setTransferDetails] = useState('');
  const [food, setFood] = useState('');
  const [foodDetails, setFoodDetails] = useState('');
  const [sightseeing, setSightseeing] = useState('');
  const [sightseeingDetails, setSightseeingDetails] = useState('');

  const [kabahotelname,  setKabahotelname] = useState('');
  const [distanceFromKaba, setDistanceFromKaba] = useState('');
  const [kabawalkdis, setKabawalkdis] = useState('');
  const [kabacar, setKabacar] = useState('');

  const [kabaDetails, setKabaDetails] = useState('');

  
  const [rawdahotelname, setRawdahotelname] = useState('');
  const [distanceFromRawda, setDistanceFromRawda] = useState('');
  const [rawdawalkdis, setRawdawalkdis] = useState('');
  const [rawdacardis, setRawdacardis] = useState('');

  const [rawdaDetails, setRawdaDetails] = useState('');
  const [departureAirline, setDepartureAirline] = useState('');
  const [arrivalAirline, setArrivalAirline] = useState('');
  const [groupTransport, setGroupTransport] = useState('');
  const [travelInsurance, setTravelInsurance] = useState('');
  const [laundryService, setLaundryService] = useState('');
  const [simIncluded, setSimIncluded] = useState('');
  const [zamzamIncluded, setZamzamIncluded] = useState('');
  const [kitIncluded, setKitIncluded] = useState('');
  const [tourGuidance, setTourGuidance] = useState('');

  const [errors, setErrors] = useState({});

     const [lastbookingdate, setlastbookingdate] = useState('');
   const [isLastBookingEdited, setIsLastBookingEdited] = useState(false);

   useEffect(() => {
  if (departureDate && !isLastBookingEdited) {
    const depDate = new Date(departureDate);

    depDate.setDate(depDate.getDate() - 11);

    const formattedDate = depDate.toISOString().split("T")[0];

    setlastbookingdate(formattedDate);
  }
}, [departureDate, isLastBookingEdited]);

  useEffect(() => {
    // console.log("Fetching initial data...");

    const fetchProducttype = async () => {
      try {
        const response = await api.get('/page/get-all');
        // console.log("Pilgrimage type response:", response.data);
        setProducttype(Array.isArray(response.data.data) ? response.data.data : []);
      } catch (error) {
        console.error('Error fetching Pilgrimage Type :', error);
      }
    };

    const fetchVendors = async () => {
      try {
        const response = await api.get('/vendor/get-all');
        // console.log("Vendors response:", response.data);
        setVendors(Array.isArray(response.data.data) ? response.data.data : []);
      } catch (error) {
        console.error('Error fetching vendors:', error);
      }
    };

    const fetchDepartureCities = async () => {
      try {
        const response = await api.get('/departurecities/get-all');
        // console.log("Departure cities response:", response.data);
        setDepartureCities(Array.isArray(response.data.data) ? response.data.data : []);
      } catch (error) {
        console.error('Error fetching departure cities:', error);
      }
    };

    const fetchAirlines = async () => {
      try {
        const response = await api.get('/airlines/get-all');
        // console.log("Airlines response:", response.data);
        setAirlinesList(Array.isArray(response.data.data) ? response.data.data : []);
      } catch (error) {
        console.error('Error fetching airlines:', error);
      }
    };

    fetchProducttype();
    fetchVendors();
    fetchDepartureCities();
    fetchAirlines();
  }, []);

  const toggle = (id) => {
    // console.log("Toggling accordion:", id, "Current open:", open);
    if (open === id) setOpen('');
    else setOpen(id);
  };

  const handleCancel = () => {
    // console.log("Cancel clicked, resetting form...");
    setPackageName('');
    setSelectedProducttype('');
    setSelectedVendor('');
    //setCity('');
    setPrice('');
    setPrice_discount('');
    setHighlights('');
    setIncluded('');
    setNotIncluded('');
    setRequirement('');
    setBookingPolicy('');
    setCancellationPolicy('');
    setImageFile(null);
    setBannerImageFile(null);
    setRoomSharing('');
    setRoomDetails('');
    setDeparturePoint('');
    setDepartureDate('');
    setlastbookingdate('');
    setDepartureDetails('');
    setArrivalPoint('');
    setArrivalDate('');
    setArrivalDetails('');
    setVisa('');
    setVisaDetails('');
    setTransfer('');
    setTransferDetails('');
    setFood('');
    setFoodDetails('');
    setSightseeing('');
    setSightseeingDetails('');
    setKabahotelname('');
    setDistanceFromKaba('');
    setKabawalkdis('');
    setKabacar('');
    setKabaDetails('');
    setRawdahotelname('');
    setDistanceFromRawda('');
    setRawdawalkdis('');
    setRawdacardis('');
    setRawdaDetails('');
    setArrivalAirline('');
    setDepartureAirline('');
    setErrors({});
    navigate('/manage-package')
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("Submitting form...");

    const errors = {};

    if (!packageName) errors.packageName = "Package Name cannot be empty";
    if (!selectedVendor) errors.selectedVendor = "Select a vendor";
    if (!selectedProducttype) errors.selectedProducttype = "Select a Product Type";
    //if (!city.trim()) errors.city = "City cannot be empty";
    if (!price.trim()) errors.price = "Price cannot be empty";
    if (!roomSharing) errors.roomSharing = "Select room sharing";
    if (!departurePoint) errors.departurePoint = "Select departure city";
    if (!departureDate) errors.departureDate = "Departure date cannot be empty";
    if (!lastbookingdate) errors.lastbookingdate = "last booking date cannot be empty";
    else if (departureDate && lastbookingdate > departureDate) {
        errors.lastbookingdate = "Must be before departure date";
       }
    if (!arrivalPoint) errors.arrivalPoint = "Arrival point is required";
    if (!arrivalDate) errors.arrivalDate = "Arrival date is required";

    const allowedImageTypes = ["image/png", "image/jpeg"];
    if (!imageFile) errors.imageFile = "Package Image cannot be empty";
    else if (!allowedImageTypes.includes(imageFile.type)) errors.imageFile = "Only PNG and JPG allowed";
    if (!bannerImageFile) errors.bannerImageFile = "Banner Image cannot be empty";
    else if (!allowedImageTypes.includes(bannerImageFile.type)) errors.bannerImageFile = "Only PNG and JPG allowed";

    if (Object.keys(errors).length > 0) {
  setErrors(errors);

  // auto-open the accordion containing the first error
  const accordionIds = [
    ...new Set(
      Object.keys(errors)
        .map((field) => fieldToAccordionMap[field])
        .filter(Boolean)
    ),
  ];

  if (accordionIds.length > 0) {
    setOpen(accordionIds[0]); // open the first accordion with error
  }

  toast.error("Please fill all required fields");
  return;
}

    setErrors({});
    const formData = new FormData();
    formData.append('packagename', packageName);
    //formData.append('city', city);
    formData.append('price', price);
    formData.append('price_discount', price_discount);    
    formData.append('highlights', highlights);
    formData.append('included', included);
    formData.append('not_included', notIncluded);
    formData.append('requirement', requirement);
    formData.append('booking_policy', bookingPolicy);
    formData.append('cancellation_policy', cancellationPolicy);
    formData.append('image_path', imageFile);
    formData.append('banner_image_path', bannerImageFile);
    formData.append('category_id', selectedProducttype);
    formData.append('vendor_id', selectedVendor);
    formData.append('room_sharing', roomSharing);
    formData.append('room_details', roomDetails);
    formData.append('departure_point', departurePoint);
    formData.append('departure_date', departureDate);
    formData.append('lastbookingdate', lastbookingdate);
    formData.append('departure_details', departureDetails);
    formData.append('arrival_point', arrivalPoint);
    formData.append('arrival_date', arrivalDate);
    formData.append('arrival_details', arrivalDetails);
    formData.append('visa', visa);
    formData.append('visa_details', visaDetails);
    formData.append('transfer', transfer);
    formData.append('transfer_details', transferDetails);
    formData.append('food', food);
    formData.append('food_details', foodDetails);
    formData.append('sightseeing', sightseeing);
    formData.append('sightseeing_details', sightseeingDetails);
    formData.append('distance_from_kaba', distanceFromKaba);
    formData.append('kabahotelname', kabahotelname);
    formData.append('kabawalkdis', kabawalkdis);
    formData.append('kabacar', kabacar);
    formData.append('kaba_details', kabaDetails);
    formData.append('rawdahotelname', rawdahotelname);
    formData.append('distance_from_rawda', distanceFromRawda);
    formData.append('rawdawalkdis', rawdawalkdis);
    formData.append('rawdacardis', rawdacardis);
    formData.append('rawda_details', rawdaDetails);
    formData.append('departure_airline', departureAirline);
    formData.append('arrival_airline', arrivalAirline);
    formData.append('group_transport', groupTransport);
    formData.append('travel_insurance', travelInsurance);
    formData.append('laundry_service', laundryService);
    formData.append('sim_included', simIncluded);
    formData.append('zamzam_included', zamzamIncluded);
    formData.append('kit_included', kitIncluded);
    formData.append('tour_guidance', tourGuidance);

    try {
      // console.log("Sending request with form data...");
      const response = await api.post('/api/product/addadmin', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      // console.log("Response:", response);
      if (response.status === 200) {
        toast.success('Package created successfully!');
        handleCancel();
      } else toast.error('Failed to create package');
    } catch (error) {
      console.error('Error creating package:', error);
      toast.error('Error creating package');
    }
  };

  return (
    <div className='floating-form-container' >
      <div className="heading">
        <h2>Package Details satrt</h2>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-container">

          {/* Basic Info */}
          <div className="section-1">
            <div className="input-container-floating-form wid-30">
              <label>Pilgrimage Type</label>
              <select className={`form-control ${errors.selectedProducttype ? 'is-invalid' : ''}`} value={selectedProducttype} onChange={(e) => setSelectedProducttype(e.target.value)}>
                <option value="">Select Pilgrimage</option>
                {producttype.map(product => <option key={product.id} value={product.id}>{product.name}</option>)}
              </select>
              {errors.selectedProducttype && <span className='text-danger small'>{errors.selectedProducttype}</span>}
            </div>

            <div className="input-container-floating-form wid-30">
              <label>Package Name</label>
              <input type="text" className={`form-control ${errors.packageName ? 'is-invalid' : ''}`} value={packageName} onChange={(e) => setPackageName(e.target.value)} placeholder="Enter Package Name" />
              {errors.packageName && <span className='text-danger small'>{errors.packageName}</span>}
            </div>

            <div className="input-container-floating-form wid-30">
              <label>Vendor</label>
              <select className={`form-control ${errors.selectedVendor ? 'is-invalid' : ''}`} value={selectedVendor} onChange={(e) => setSelectedVendor(e.target.value)}>
                <option value="">Select Vendor</option>
                {vendors.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
              </select>
              {errors.selectedVendor && <span className='text-danger small'>{errors.selectedVendor}</span>}
            </div>

            {/* <div className="input-container-floating-form wid-50">
              <label>City</label>
              <input type="text" className={`form-control ${errors.city ? 'is-invalid' : ''}`} value={city} onChange={(e) => setCity(e.target.value)} placeholder="Enter City" />
              {errors.city && <span className='text-danger small'>{errors.city}</span>}
            </div> */}

            <div className="input-container-floating-form wid-50">
              <label>Price</label>
              <input type="number" className={`form-control ${errors.price ? 'is-invalid' : ''}`} value={price} onChange={(e) => setPrice(e.target.value)} placeholder="Enter Price" />
              {errors.price && <span className='text-danger small'>{errors.price}</span>}
            </div>
            <div className='mb-3 input-container-floating-form wid-50'>
                      <label>Discount  Price(only in %)*</label>
                      <input type="number" className={`form-control ${errors.price_discount ? 'is-invalid' : ''}`} value={price_discount} onChange={(e) => setPrice_discount(e.target.value)} placeholder="Enter Discount (%)" />
                      <b>{errors.price_discount && <span className='text-danger small'>{errors.price_discount}</span>}</b>
            </div>
          </div>

{/* Section-2 Departure (Full Width) */}
<div className="w-100">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="Departure" className={(errors.departurePoint || errors.departureDate) ? "accordion-error" : ""}>Departure Details</AccordionHeader>
      <AccordionBody accordionId="Departure">
        
        {/* Row: Departure Point + Date + Airline */}
        <div className="row g-3">
          {/* Departure Point */}
          <div className="col-md-4">
            <div className="input-container-floating-form">
              <label>Departure Point</label>
              <select
                className={`form-control ${errors.departurePoint ? "is-invalid" : ""}`}
                value={departurePoint}
                onChange={(e) => setDeparturePoint(e.target.value)}
              >
                <option value="">Select Departure City</option>
                {departureCities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.dcityname}
                  </option>
                ))}
              </select>
              {errors.departurePoint && (
                <span className="text-danger small">{errors.departurePoint}</span>
              )}
            </div>
          </div>

          {/* Departure Date */}
          <div className="col-md-4">
            <div className="input-container-floating-form">
              <label>Departure Date</label>
              <input
                type="date"
                //className={`form-control ${errors.departureDate ? "is-invalid" : ""}`}
                value={departureDate}
                onChange={(e) => setDepartureDate(e.target.value)}
              />
              {errors.departureDate && (
                <span className="text-danger small">{errors.departureDate}</span>
              )}
            </div>
          </div>

          {/*Departure Airline */}
          <div className="col-md-4">
            <div className="input-container-floating-form">
              <label>Departure Airline</label>
              <select
                className="form-control"
                value={departureAirline}
                onChange={(e) => setDepartureAirline(e.target.value)}
              >
                <option value="">Select Airline</option>
                {airlinesList.map((a) => (
                  <option key={a.id} value={a.id}>
                    {a.airline_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

              <div className='mt-3 input-container-floating-form wid-50'>
                          <label>last date of Booking</label>
                          <input
                            type="date"
                            value={lastbookingdate}
                            onChange={(e) =>{ setlastbookingdate(e.target.value);setIsLastBookingEdited(true); }}
                          />
                          {errors.lastbookingdate && (
                            <span className="text-danger small">{errors.lastbookingdate}</span>
                          )}
              </div>

        {/* Departure Details (Quill) */}
        <div className="input-container-floating-form wid-100 mt-3">
          <label>Departure Description</label>
          <ReactQuill
            theme="snow"
            value={departureDetails}
            onChange={setDepartureDetails}
          />
        </div>

      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section-3  Arrival Details */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="Arrival" className={(errors.arrivalPoint || errors.arrivalDate) ? "accordion-error" : ""}>Arrival Details</AccordionHeader>
      <AccordionBody accordionId="Arrival">
        
        {/* Row: Departure Point + Date + Airline */}
        <div className="row g-3">
          {/* Arrival Point */}
          <div className="col-md-4">
            <div className="input-container-floating-form">
              <label>Arrival Point</label>
              <select
                className={`form-control ${errors.arrivalPoint ? "is-invalid" : ""}`}
                value={arrivalPoint}
                onChange={(e) => setArrivalPoint(e.target.value)}
              >
                <option value="">Select Arrival City</option>
                {departureCities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.dcityname}
                  </option>
                ))}
              </select>
                {errors.arrivalPoint && (
                  <span className="text-danger small">{errors.arrivalPoint}</span>
                )}

            </div>
          </div>

          {/* Arrival Date */}
          <div className="col-md-4">
            <div className="input-container-floating-form">
              <label>Arrival Date</label>
              <input
                type="date"
                className={`form-control ${errors.arrivalDate ? "is-invalid" : ""}`}
                value={arrivalDate}
                onChange={(e) => setArrivalDate(e.target.value)}
              />
              {errors.arrivalDate && <span className="text-danger small">{errors.arrivalDate}</span>}

            </div>
          </div>

          {/* Arrival Airline */}
          <div className="col-md-4">
            <div className="input-container-floating-form">
              <label>Arrival Airline</label>
              <select
                className="form-control"
                value={arrivalAirline}
                onChange={(e) => setArrivalAirline(e.target.value)}
              >
                <option value="">Select Airline</option>
                {airlinesList.map((a) => (
                  <option key={a.id} value={a.id}>
                    {a.airline_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Arrival Details (Quill) */}
        <div className="input-container-floating-form wid-100 mt-3">
          <label>Arrival Description</label>
          <ReactQuill
            theme="snow"
            value={arrivalDetails}
            onChange={setArrivalDetails}
          />
        </div>

      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section-4 - Visa */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="visa-details">Visa Details</AccordionHeader>
      <AccordionBody accordionId="visa-details">
        
        {/* Visa Input (Single line) */}
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <div className="input-container-floating-form">
              <label>Visa</label>
              <input
                type="text"
                className="form-control"
                value={visa}
                onChange={(e) => setVisa(e.target.value)}
                placeholder="Enter Visa"
              />
            </div>
          </div>
        </div>

        {/* Visa Description (Full width with Quill) */}
        <div className="input-container-floating-form w-100">
          <label>Visa Description</label>
          <ReactQuill
            theme="snow"
            value={visaDetails}
            onChange={setVisaDetails}
          />
        </div>
      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>


{/* Section-5 Room */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="room-details" className={errors.roomSharing ? "accordion-error" : ""}>Room Details</AccordionHeader>
      <AccordionBody accordionId="room-details">
        
        {/* Room Sharing (dropdown) */}
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <div className="input-container-floating-form">
              <label htmlFor="roomSharing">Room Sharing</label>
              <select
                className={`form-control ${errors.roomSharing ? "is-invalid" : ""}`}
                value={roomSharing}
                onChange={(e) => setRoomSharing(e.target.value)}
              >
                <option value="">Select room sharing</option>
                <option value="single">Single</option>
                <option value="double">Double</option>
                <option value="triple">Triple</option>
                <option value="quad">Quad</option>
                <option value="five">Five</option>
                <option value="six">Six</option>
              </select>
              {errors.roomSharing && (
                <span className="text-danger small">{errors.roomSharing}</span>
              )}
            </div>
          </div>
        </div>

        {/* Room Description (full width) */}
        <div className="input-container-floating-form w-100">
          <label>Room Description</label>
          <ReactQuill
            theme="snow"
            value={roomDetails}
            onChange={setRoomDetails}
          />
        </div>
      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Kaba */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="kaba-details">Kaba Distance Details</AccordionHeader>
      <AccordionBody accordionId="kaba-details">

        {/* Distance From Kaba */}
        <div className="row g-3 mb-3">
               <div className="col-md-3">
            <div className="input-container-floating-form">
              <label>Kaba Hotel Name(In Km)</label>
              <input
                type="text"
                className="form-control"
                value={kabahotelname}
                onChange={(e) => setKabahotelname(e.target.value)}
                placeholder="Enter Hotel Name"
              />
            </div>
          </div>

              <div className="col-md-3">
            <div className="input-container-floating-form">
              <label>Distance  (In Km)</label>
              <input
                type="text"
                className="form-control"
                value={distanceFromKaba}
                onChange={(e) => setDistanceFromKaba(e.target.value)}
                placeholder="Enter distance"
              />
            </div>
          </div>
            <div className="col-md-3">
            <div className="input-container-floating-form">
              <label>Walk Distance (In Km)</label>
              <input
                type="text"
                className="form-control"
                value={kabawalkdis}
                onChange={(e) => setKabawalkdis(e.target.value)}
                placeholder="Enter Walk Distance"
              />
            </div>
          </div>
            <div className="col-md-3">
            <div className="input-container-floating-form">
              <label>Car Distance  (In Km)</label>
              <input
                type="text"
                className="form-control"
                value={kabacar}
                onChange={(e) => setKabacar(e.target.value)}
                placeholder="Enter Car Distance"
              />
            </div>
          </div>
        </div>

        {/* Kaba Details (Full Width with Quill) */}
        <div className="input-container-floating-form w-100">
          <label>Kaba Description</label>
          <ReactQuill
            theme="snow"
            value={kabaDetails}
            onChange={setKabaDetails}
          />
        </div>

      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Rawda */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="rawda-details">Rawda Distance Details</AccordionHeader>
      <AccordionBody accordionId="rawda-details">

        {/* Distance From Rawda */}
        <div className="row g-3 mb-3">
         <div className="col-md-3">
            <div className="input-container-floating-form">
              <label>Rawda Hotel Name </label>
              <input
                type="text"
                className="form-control"
                value={rawdahotelname}
                onChange={(e) => setRawdahotelname(e.target.value)}
                placeholder="Enter Rawda Hotel Name"
              />
            </div>
          </div>

            <div className="col-md-3">
            <div className="input-container-floating-form">
              <label>Distance  (In Km)</label>
              <input
                type="text"
                className="form-control"
                value={distanceFromRawda}
                onChange={(e) => setDistanceFromRawda(e.target.value)}
                placeholder="Enter distance"
              />
            </div>
          </div>
            <div className="col-md-3">
            <div className="input-container-floating-form">
              <label>Walk Distance (In Km)</label>
              <input
                type="text"
                className="form-control"
                value={rawdawalkdis}
                onChange={(e) => setRawdawalkdis(e.target.value)}
                placeholder="Enter Walk Distance"
              />
            </div>
          </div>
            <div className="col-md-3">
            <div className="input-container-floating-form">
              <label>Car Distance  (In Km)</label>
              <input
                type="text"
                className="form-control"
                value={rawdacardis}
                onChange={(e) => setRawdacardis(e.target.value)}
                placeholder="Enter Car Distance"
              />
            </div>
          </div>
        </div>

        {/* Rawda Details (Full Width with Quill) */}
        <div className="input-container-floating-form w-100">
          <label>Rawda Description</label>
          <ReactQuill
            theme="snow"
            value={rawdaDetails}
            onChange={setRawdaDetails}
          />
        </div>

      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Sightseeing */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="sightseeing-details">Sightseeing Details</AccordionHeader>
      <AccordionBody accordionId="sightseeing-details">

        {/* Sightseeing Input */}
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <div className="input-container-floating-form">
              <label>Sightseeing </label>
              <input
                type="text"
                className="form-control"
                value={sightseeing}
                onChange={(e) => setSightseeing(e.target.value)}
                placeholder="Enter sightseeing"
              />
            </div>
          </div>
        </div>

        {/* Sightseeing Description (Full Width with Quill) */}
        <div className="input-container-floating-form w-100">
          <label>Sightseeing Description</label>
          <ReactQuill
            theme="snow"
            value={sightseeingDetails}
            onChange={setSightseeingDetails}
          />
        </div>

      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Food */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="food-details">Food Details</AccordionHeader>
      <AccordionBody accordionId="food-details">

        {/* Food Input */}
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <div className="input-container-floating-form">
              <label>Food</label>
              <input
                type="text"
                className="form-control"
                value={food}
                onChange={(e) => setFood(e.target.value)}
                placeholder="Enter food"
              />
            </div>
          </div>
        </div>

        {/* Food Details (Full Width with Quill) */}
        <div className="input-container-floating-form w-100">
          <label>Food Description</label>
          <ReactQuill
            theme="snow"
            value={foodDetails}
            onChange={setFoodDetails}
          />
        </div>

      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Transfer */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="transfer-details">Transfer Details</AccordionHeader>
      <AccordionBody accordionId="transfer-details">

        {/* Transfer Input */}
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <div className="input-container-floating-form">
              <label>Transfer</label>
              <input
                type="text"
                className="form-control"
                value={transfer}
                onChange={(e) => setTransfer(e.target.value)}
                placeholder="Enter transfer info"
              />
            </div>
          </div>
        </div>

        {/* Transfer Details (Full Width with Quill) */}
        <div className="input-container-floating-form w-100">
          <label>Transfer Description</label>
          <ReactQuill
            theme="snow"
            value={transferDetails}
            onChange={setTransferDetails}
          />
        </div>

      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Highlights */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="highlights-details">Highlights Details</AccordionHeader>
      <AccordionBody accordionId="highlights-details">

        {/* Highlights (Full Width with Quill) */}
        <div className="input-container-floating-form w-100">
          <label>Highlights</label>
          <ReactQuill
            theme="snow"
            value={highlights}
            onChange={setHighlights}
          />
        </div>

      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Included */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="included-details">Included Details</AccordionHeader>
      <AccordionBody accordionId="included-details">
        <div className="input-container-floating-form w-100">
          <ReactQuill theme="snow" value={included} onChange={setIncluded} />
        </div>
      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Not Included */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="not-included-details">Not Included Details</AccordionHeader>
      <AccordionBody accordionId="not-included-details">
        <div className="input-container-floating-form w-100">
          <ReactQuill theme="snow" value={notIncluded} onChange={setNotIncluded} />
        </div>
      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Requirements */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="requirements-details">Requirements Details</AccordionHeader>
      <AccordionBody accordionId="requirements-details">
        <div className="input-container-floating-form w-100">
          <ReactQuill theme="snow" value={requirement} onChange={setRequirement} />
        </div>
      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Booking Policy */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="booking-policy-details">Booking Policy Details</AccordionHeader>
      <AccordionBody accordionId="booking-policy-details">
        <div className="input-container-floating-form w-100">
          <ReactQuill theme="snow" value={bookingPolicy} onChange={setBookingPolicy} />
        </div>
      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Cancellation Policy */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="cancellation-policy-details">Cancellation Policy Details</AccordionHeader>
      <AccordionBody accordionId="cancellation-policy-details">
        <div className="input-container-floating-form w-100">
          <ReactQuill theme="snow" value={cancellationPolicy} onChange={setCancellationPolicy} />
        </div>
      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="additional-services">
        Additional Services
      </AccordionHeader>

      <AccordionBody accordionId="additional-services">
        <div className="row g-3">

          <div className="col-md-4">
            <label>Group Transport</label>
            <input className="form-control"
              value={groupTransport}
              onChange={(e) => setGroupTransport(e.target.value)} />
          </div>

          <div className="col-md-4">
            <label>Travel Insurance</label>
            <input className="form-control"
              value={travelInsurance}
              onChange={(e) => setTravelInsurance(e.target.value)} />
          </div>

          <div className="col-md-4">
            <label>Laundry Service</label>
            <input className="form-control"
              value={laundryService}
              onChange={(e) => setLaundryService(e.target.value)} />
          </div>

          <div className="col-md-4">
            <label>SIM Included</label>
            <input className="form-control"
              value={simIncluded}
              onChange={(e) => setSimIncluded(e.target.value)} />
          </div>

          <div className="col-md-4">
            <label>Zamzam Included</label>
            <input className="form-control"
              value={zamzamIncluded}
              onChange={(e) => setZamzamIncluded(e.target.value)} />
          </div>

          <div className="col-md-4">
            <label>Kit Included</label>
            <input className="form-control"
              value={kitIncluded}
              onChange={(e) => setKitIncluded(e.target.value)} />
          </div>

          <div className="col-md-4">
            <label>Tour Guidance</label>
            <input className="form-control"
              value={tourGuidance}
              onChange={(e) => setTourGuidance(e.target.value)} />
          </div>

        </div>
      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

{/* Section - Images */}
<div className="w-100 mt-3">
  <Accordion open={open} toggle={toggle}>
    <AccordionItem>
      <AccordionHeader targetId="images-details" className={(errors.imageFile || errors.bannerImageFile) ? "accordion-error" : ""}>
        Package & Banner Images Details
      </AccordionHeader>
      <AccordionBody accordionId="images-details">

        <div className="row g-3 mb-3">

          {/* Package Image */}
          <div className="col-md-6">
            <div className="input-container-floating-form">
              <label htmlFor="logo">
                Package Image * <br /> (only png and jpg size 251px*168px)
              </label>

              <div className="file-select">
                <div className="file-select-button">Choose File</div>
                <div className="file-select-name">
                  {imageFile?.name || "No file chosen..."}
                </div>
                <input
                  type="file"
                  id="logo"
                  accept="image/*"
                  onChange={(e) => setImageFile(e.target.files[0])}
                />
              </div>

              {errors.imageFile && (
                <b>
                  <span className="text-danger small">{errors.imageFile}</span>
                </b>
              )}
            </div>
          </div>

          {/* Banner Image */}
          <div className="col-md-6">
            <div className="input-container-floating-form">
              <label htmlFor="banner">
                Banner Image * <br /> (only png and jpg size 251px*168px)
              </label>

              <div className="file-select">
                <div className="file-select-button">Choose File</div>
                <div className="file-select-name">
                  {bannerImageFile?.name || "No file chosen..."}
                </div>
                <input
                  type="file"
                  id="banner"
                  accept="image/*"
                  onChange={(e) => setBannerImageFile(e.target.files[0])}
                />
              </div>

              {errors.bannerImageFile && (
                <b>
                  <span className="text-danger small">{errors.bannerImageFile}</span>
                </b>
              )}
            </div>
          </div>

        </div>

      </AccordionBody>
    </AccordionItem>
  </Accordion>
</div>

        <div className="form-btn-container">
          <button type='submit'>send for approval from vender</button>
          <button type='button' onClick={handleCancel}>Cancel</button>
        </div>

        </div>



      </form>
    </div>
  );
};

export default CreatePackageInPage;
